// Stage 1, Diagnostics. Presentational only.

import React from 'react';
import {
  Caveat, EvidenceBasis, EvidenceQuotes, FindingHeading, Heading, NullableBlock, Prose,
  ScoreResult, StrengthList, TaskStatusRow, TraitLevelRow,
} from './TaraFeedbackBlocks';

export default function TaraDiagnosticFeedback({ feedback, spans }) {
  if (!feedback) return null;
  const stall = feedback.main_point_where_reasoning_stalled;
  const judgement = feedback.current_judgement_quality;

  return (
    <div className="tara-fb-body">
      <ScoreResult result={feedback.assessment_result} />
      <Prose>{feedback.overall_diagnostic_summary}</Prose>
      <EvidenceQuotes spans={spans} spanIds={feedback.summary_evidence_span_ids} />

      {Array.isArray(feedback.task_breakdown) && feedback.task_breakdown.length ? (
        <section className="tara-fb-group">
          <Heading>The three tasks</Heading>
          {feedback.task_breakdown.map((task, i) => (
            <TaskStatusRow key={i} task={task} spans={spans} />
          ))}
        </section>
      ) : null}

      {Array.isArray(feedback.reasoning_profile) && feedback.reasoning_profile.length ? (
        <section className="tara-fb-group">
          <Heading>Your reasoning, trait by trait</Heading>
          {feedback.reasoning_profile.map((trait, i) => (
            <TraitLevelRow key={i} trait={trait} />
          ))}
        </section>
      ) : null}

      <NullableBlock value={stall}>
        <section className="tara-fb-group">
          {stall && stall.headline
            ? <FindingHeading>{stall.headline}</FindingHeading>
            : <Heading>Where the reasoning stalled</Heading>}
          <Prose>{stall && stall.explanation}</Prose>
          <Prose className="tara-fb-soft">{stall && stall.why_it_limited_the_essay}</Prose>
          <EvidenceQuotes spans={spans} spanIds={stall && stall.evidence_span_ids} />
          <EvidenceBasis>{stall && stall.evidence_basis}</EvidenceBasis>
        </section>
      </NullableBlock>

      {Array.isArray(feedback.reasoning_strengths) && feedback.reasoning_strengths.length ? (
        <section className="tara-fb-group">
          <Heading>What worked</Heading>
          <StrengthList
            items={feedback.reasoning_strengths}
            spans={spans}
            whyKey="why_it_helped_the_essay"
          />
        </section>
      ) : null}

      <NullableBlock value={judgement}>
        <section className="tara-fb-group">
          <Heading>Your final judgement</Heading>
          <Prose>{judgement && judgement.explanation}</Prose>
          <EvidenceQuotes spans={spans} spanIds={judgement && judgement.evidence_span_ids} />
          <EvidenceBasis>{judgement && judgement.evidence_basis}</EvidenceBasis>
        </section>
      </NullableBlock>

      <Prose className="tara-fb-takeaway">{feedback.diagnostic_takeaway}</Prose>
      <Caveat>{feedback.limitations_note}</Caveat>
    </div>
  );
}
